UARequirePasswordResetCtrl.$inject = ['users', 'auth', 'adminApi', 'modalTitleID']

export default function UARequirePasswordResetCtrl(users, auth, adminApi, modalTitleID) {
  this.modalTitleID = modalTitleID
  this.users = users
  this.log = []
  this.showError = false
  this.errorMessage = ''
  this.loading = false
  this.completed = false
  this.ssoUserEmails = this.users
    .filter(u => u.sso_provider_ids && u.sso_provider_ids.length > 0)
    .map(u => u.email)
  this.ssoProviderIDs = [
    ...users.reduce((idSet, user) => {
      if (user.sso_provider_ids) {
        user.sso_provider_ids.forEach(id => idSet.add(id))
      }
      return idSet
    }, new Set())
  ]

  this.continueAction = async function() {
    this.loading = true
    this.showError = false

    var userUuids = this.users.map(function(u) {
      return u.uuid
    })

    try {
      const requiredAtTime = new Date().toISOString().replace('T', ' ') // This is to ensure timestamp formatting is consistent with how the users app reads/writes timestamps
      this.log.push(`Updating password_reset_required_at field to ${requiredAtTime}`)
      await adminApi.batchUpdateAccounts(userUuids, {
        password_reset_required_at: requiredAtTime
      })
      this.log.push(`Signing ${userUuids.length} user(s) out`)
      await Promise.all(userUuids.map(uuid => auth.clearUserSessions(uuid)))
      this.loading = false
      this.log.push(`Done!`)
      this.completed = true
    } catch (err) {
      this.showError = true
      this.log.push('Error!')
      this.errorMessage = JSON.stringify(err)
    }
    this.loading = false
  }.bind(this)
}
